<script>
import MultiSelect from "vue-multiselect";
import { required } from "vuelidate/lib/validators";
import JsonExcel from "vue-json-excel";

// Custom Components
import PageHeader from "@/components/page-header";
import hkService from "@/helpers/APIService/hk.service";
import Middleware from "@/helpers/middlewares";
import errorHandler from "@/helpers/errorHandler";
import { authComputed } from "@/state/helpers";
import appConfig from "@/app.config";

// Cleaning Task Component
let id = "";
export default {
  page: {
    title: "Payment Report",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    PageHeader,
    MultiSelect,
    downloadExcel: JsonExcel,
  },
  computed: {
    ...authComputed,
  },
  data() {
    return {
      title: "Clean Task Sheet",
      table: {
        isDataLoading: false,
        tableData: [],
      },
      task_fields: {
        Room: "room",
        "Task Type": "task_type",
        "Task Sheet Name": "task_sheet_name",
        "Task Status": "task_status",
        "OC Status": "oc_status",
        "Res Status": "res_status",
        "Room Status": "room_status",
        Attendant: "attendant",
        Inspection: "inspection",
        "Room Type": "room_type",
        Credit: "credit",
        Comments: "comments",
        "Start Time": "start_time",
        "End Time": "end_time",
        "Remaining Time": "remaining_time",
        "Guest Name": "guest_name",
      },
      totalStaff: 0,
      online: 0,
      offline: 0,
      totalTask: 0,
      dirty: 0,
      in_progress: 0,
      paused: 0,
      rejected: 0,
      discrepancy: 0,
      cleaned: 0,
      reasonTitle: "",
      reasonStatus: "",
      reason: "",
      reasonOptions: [],
      submitted: false,
      taskId: "",
      taskSheetDetails: "",
      sheet_id: null,
      sheet_date: null,
    };
  },
  mounted() {
    this.getTaskSheetListByDate();
  },
  methods: {
    // Method is use for get current date task list for console
    getTaskSheetListByDate() {
      this.table.tableData = [];
      this.table.isDataLoading = true;
      const data = JSON.parse(localStorage.getItem("task"));
      id = data.id;
      hkService
        .getTaskSheetListByDate(data.date)
        .then((response) => {
          let tempArr = [];
          this.totalStaff = 0;
          this.online = 0;
          this.offline = 0;
          this.totalTask = 0;
          this.dirty = 0;
          this.in_progress = 0;
          this.paused = 0;
          this.rejected = 0;
          this.discrepancy = 0;
          this.cleaned = 0;
          let tempStaffArr = [];

          response.map((item) => {
            this.taskSheetDetails = item.task_sheet;

            item.hkstafftask_set.map((task) => {
              let statusOptions = [];
              this.totalTask += 1;
              if (task.task_status == "hk_pending") {
                statusOptions.push(
                  { name: "In Process", type: "hk_in_progress" },
                  { name: "Discrepancy", type: "hk_discrepancy" },
                  { name: "DND", type: "hk_dnd" }
                );
              } else if (task.task_status == "hk_in_progress") {
                statusOptions.push(
                  { name: "Paused", type: "mark_delay_service" },
                  { name: "Completed", type: "hk_completed" }
                );
              } else if (
                task.task_status == "hk_discrepancy" ||
                task.task_status == "hk_dnd"
              ) {
                statusOptions.push(
                  { name: "Discrepancy", type: "hk_discrepancy" },
                  { name: "DND", type: "hk_dnd" },
                  { name: "In Progress", type: "hk_in_progress" },
                  { name: "Paused", type: "mark_delay_service" }
                );
              } else if (task.task_status == "mark_delay_service") {
                statusOptions.push(
                  { name: "In Progress", type: "hk_in_progress" },
                  { name: "Completed", type: "hk_completed" }
                );
              } else if (task.task_status == "hk_completed") {
                statusOptions.push(
                  { name: "Inspection Rejected", type: "in_reject" },
                  { name: "Inspection Panding", type: "in_pending" },
                  { name: "Inspection Done", type: "in_done" }
                );
              } else if (task.task_status == "in_pending") {
                statusOptions.push(
                  { name: "Inspection Rejected", type: "in_reject" },
                  {
                    name: "Inspection Done",
                    type: "in_done",
                  }
                );
              }
              if (task.task_status == "hk_pending") {
                this.dirty += 1;
                task.task_status = "Pending";
              } else if (task.task_status == "hk_in_progress") {
                this.in_progress += 1;
                task.task_status = "In Progress";
              } else if (task.task_status == "hk_discrepancy") {
                this.discrepancy += 1;
                task.task_status = "Discrepancy";
              } else if (task.task_status == "hk_dnd") {
                task.task_status = "DND";
              } else if (task.task_status == "hk_completed") {
                this.cleaned += 1;
                task.task_status = "Completed";
              } else if (task.task_status == "mark_delay_service") {
                this.paused += 1;
                task.task_status = "Paused";
              } else if (task.task_status == "in_reject") {
                this.rejected += 1;
                task.task_status = "Rejected";
              } else if (task.task_status == "in_pending") {
                task.task_status = "In Pending";
              } else if (task.task_status == "in_done") {
                task.task_status = "In Done";
              }
              if (!tempStaffArr.includes(item.staff_user.id)) {
                this.totalStaff += 1;
                tempStaffArr.push(item.staff_user.id);
              }
              tempArr.push({
                statusOptions: statusOptions,
                taskId: task.id,
                room: task.room.room_number,
                task_type: task.task_type,
                task_sheet_name: item.task_sheet.sheet_id,
                task_status: task.task_status,
                oc_status: task.room.occupancy_status,
                res_status:
                  task.booking !== undefined && task.booking.status != undefined
                    ? task.booking.status
                    : "-",
                room_status: task.room.hk_status,
                staff_image:
                  item.staff_user !== undefined
                    ? item.staff_user.profile_picture
                    : "",
                attendant:
                  item.staff_user !== undefined
                    ? item.staff_user.first_name +
                      " " +
                      item.staff_user.last_name
                    : "-",
                inspection: task.is_inspection_required,
                room_type: task.room.room_type.short_name,
                credit: task.credit,
                comments: "",
                start_time:
                  task.start_time !== null ? task.start_time : "00:00",
                end_time: task.end_time !== null ? task.end_time : "00:00",
                remaining_time:
                  task.remaining_time !== undefined ? task.remaining_time : "-",
                guest_name:
                  task.booking != undefined && task.booking.guest != undefined
                    ? task.booking.guest.name
                    : "-",
              });
            });
          });
          tempArr.sort(function (a, b) {
            return a.room - b.room;
          });
          this.table.tableData = tempArr;
          this.table.isDataLoading = false;
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is use for get avatar text
    avatarGenerator(name) {
      return Middleware.avatarGenerator(name);
    },
    // Method is use for update task status
    updateStatus(taskId, status) {
      this.taskId = taskId;
      if (status === "hk_dnd") {
        this.reasonOptions = [];
        this.reason = "";
        this.reasonTitle = "Select DND Reason";
        this.reasonStatus = "DND";
        hkService
          .getDNDReasonList()
          .then((response) => {
            response.map((item) => {
              if (item.is_active) {
                this.reasonOptions.push({
                  value: item.id,
                  text: item.name,
                  disabled: false,
                });
              }
            });
          })
          .catch((error) => {
            errorHandler(error);
          });

        this.$refs["reason-modal"].show();
      } else if (status === "hk_discrepancy") {
        this.reasonOptions = [];
        this.reason = "";
        this.taskId = taskId;
        this.reasonTitle = "Select Discrepancy Reason";
        this.reasonStatus = "Discrepancy";
        hkService
          .getDiscrepancyReasonList()
          .then((response) => {
            response.map((item) => {
              this.reasonOptions.push({
                value: item.id,
                text: item.name,
                disabled: false,
              });
            });
          })
          .catch((error) => {
            errorHandler(error);
          });

        this.$refs["reason-modal"].show();
      } else {
        hkService
          .updateTaskStatus(taskId, {
            task_status: status,
          })
          .then((response) => {
            this.getTaskSheetListByDate();
            Middleware.notification("Task Status updated !!", "success");
          })
          .catch((error) => {
            errorHandler(error);
          });
      }
    },
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.handleSubmit();
    },
    // Method is use for update DND and Discrepancy reason
    handleSubmit() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        this.submitted = false;
        let status = "";
        if (this.reasonStatus == "DND") {
          status = "hk_dnd";
        }
        if (this.reasonStatus == "Discrepancy") {
          status = "hk_discrepancy";
        }
        hkService
          .updateTaskStatus(this.taskId, {
            task_status: status,
            task_status_change_reason: this.reason.name,
          })
          .then((response) => {
            this.getTaskSheetListByDate();
            this.resetModal();
            Middleware.notification("Task Status updated !!", "success");
          })
          .catch((error) => {
            errorHandler(error);
          });
      }
    },
    resetModal() {
      this.$refs["reason-modal"].hide();
    },
    backToTaskDetails() {
      this.$router.push({ path: `/view-task-sheet/${id}` });
    },
  },
  validations: {
    reason: { required },
  },
};
</script>

<template>
  <div>
    <PageHeader
      :title="title"
      :isIcon="true"
      :classValue="'fa fas fa-long-arrow-alt-left fa-2x'"
      :action="backToTaskDetails"
      :hoverValue="'Back to task details'"
    />
    <div
      class="d-flex justify-content-between align-items-center bg-lightgray p-2"
    >
      <h5 class="mb-0">
        #{{ taskSheetDetails.sheet_id }} {{ taskSheetDetails.title }}
      </h5>
      <download-excel
        class="btn btn-default btn-primary"
        variant="primary"
        :data="table.tableData"
        :fields="task_fields"
        worksheet="My Worksheet"
        name="clean_task_sheet.xls"
      >
        Download Excel Sheet<i class="fas fa-file-alt ms-2"></i>
      </download-excel>
    </div>
    <div class="card p-3">
      <div class="col-md-12">
        <div class="d-flex align-items-center flex-wrap mb-3">
          <div class="me-3">
            <h6>
              Total Staff : <span class="total-number">{{ totalStaff }}</span>
            </h6>
          </div>
          <div class="me-3">
            <h6>
              Online : <span class="total-number">{{ online }}</span>
            </h6>
          </div>
          <div class="me-3">
            <h6>
              Offline : <span class="total-number">{{ offline }}</span>
            </h6>
          </div>
          <div class="me-3">
            <h6>
              Total Task : <span class="total-number">{{ totalTask }}</span>
            </h6>
          </div>
          <div class="me-3">
            <h6>
              Dirty : <span class="total-number">{{ dirty }}</span>
            </h6>
          </div>
          <div class="me-3">
            <h6>
              In-Progress : <span class="total-number">{{ in_progress }}</span>
            </h6>
          </div>
          <div class="me-3">
            <h6>
              Paused : <span class="total-number">{{ paused }}</span>
            </h6>
          </div>
          <div class="me-3">
            <h6>
              Rejected : <span class="total-number">{{ rejected }}</span>
            </h6>
          </div>
          <div class="me-3">
            <h6>
              Discrepancy : <span class="total-number">{{ discrepancy }}</span>
            </h6>
          </div>
          <div class="me-3">
            <h6>
              Cleaned : <span class="total-number">{{ cleaned }}</span>
            </h6>
          </div>

          <div class="ms-auto me-2">
            <i
              v-if="!table.isDataLoading"
              class="fas fa-redo"
              v-b-popover.hover.bottom="'Refresh console'"
              @click="getTaskSheetListByDate()"
            ></i>
            <i v-else class="bx bx-revision bx-spin toggle-right fs-4"></i>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="table-responsive mb-4" v-dragscroll>
          <table class="table table-hover mb-0">
            <thead>
              <tr class="bg-lightgray hk-center">
                <th>Room</th>
                <th>Task Type</th>
                <th>Sheet ID</th>
                <th>Task Status</th>
                <th v-b-popover.hover="'Occupancy Status'">OC Status</th>
                <th>Res.Status</th>
                <th>Room status</th>
                <th class="text-center"><i class="fas fa-user"></i></th>
                <th>Attendant</th>
                <th>Inspection</th>
                <th>Room Type</th>
                <th>Credits</th>
                <th>Start Time</th>
                <th>End Time</th>
                <th>Remaining</th>
                <th>Guest Name</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody v-if="table.isDataLoading">
              <tr v-for="index in 20" :key="index">
                <td class="placeholder-glow" v-for="no in 17" :key="no">
                  <span class="placeholder w-100 placeholder-lg"></span>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr
                v-for="(data, index) in table.tableData"
                :key="index"
                class="hk-center"
              >
                <td>{{ data.room }}</td>
                <td class="text-capitalize">{{ data.task_type }}</td>
                <td>{{ data.task_sheet_name }}</td>
                <td class="text-capitalize">
                  <span
                    class="badge align-items-center py-1 px-2 card-badge"
                    :class="[
                      data.task_status == 'Pending' ||
                      data.task_status == 'In Progress'
                        ? 'badge-soft-warning'
                        : data.task_status == 'Completed'
                        ? 'badge-soft-success'
                        : data.task_status == 'Discrepancy' ||
                          data.task_status == 'DND'
                        ? 'badge-soft-secondary'
                        : data.task_status == 'Rejected'
                        ? 'badge-soft-danger'
                        : data.task_status == 'In Pending'
                        ? 'badge-soft-primary'
                        : data.task_status == 'In Done'
                        ? 'badge-soft-info'
                        : data.task_status == 'Paused'
                        ? 'badge-soft-dark'
                        : 'badge-soft-info',
                    ]"
                  >
                    {{ data.task_status }}
                  </span>
                </td>
                <td>
                  <span
                    class="badge align-items-center py-1 px-2 card-badge"
                    :class="[
                      data.occupancy_status == 'v'
                        ? 'badge-soft-primary'
                        : data.occupancy_status == 'o'
                        ? 'badge-soft-success'
                        : data.occupancy_status == 'b'
                        ? 'badge-soft-dark'
                        : data.occupancy_status == 'ooo'
                        ? 'badge-soft-warning'
                        : data.occupancy_status == 'oos'
                        ? 'badge-soft-danger'
                        : 'badge-soft-dark',
                    ]"
                  >
                    {{
                      data.oc_status == "ooo"
                        ? "Out Of Order"
                        : data.oc_status == "oos"
                        ? "Out of Service"
                        : data.oc_status == "b"
                        ? "Blocked"
                        : data.oc_status == "o"
                        ? "Occupied"
                        : "Vacant"
                    }}
                  </span>
                </td>
                <td>
                  <span
                    class="badge align-items-center py-1 px-2 card-badge"
                    :class="[
                      data.res_status === 'new_booking' ||
                      data.res_status === 'pre_checkin' ||
                      data.res_status === 'reservation' ||
                      data.res_status === 'pre_checked_done'
                        ? 'badge-soft-info'
                        : data.res_status === 'checked_in'
                        ? 'badge-soft-success'
                        : data.res_status === 'cancelled' ||
                          data.res_status === 'no_show'
                        ? 'badge-soft-danger'
                        : data.res_status === 'checked_out'
                        ? 'badge-soft-warning'
                        : 'badge-soft-secondary',
                    ]"
                  >
                    {{
                      data.res_status === "new_booking" ||
                      data.res_status == "pre_checkin"
                        ? "New Booking"
                        : data.res_status === "reservation"
                        ? "Reservation"
                        : data.res_status === "pre_checked_done"
                        ? "Pre Checked-In"
                        : data.res_status === "checked_in"
                        ? "Checked In"
                        : data.res_status === "checked_out"
                        ? "Checked Out"
                        : data.res_status === "cancelled"
                        ? "Cancelled"
                        : "No Show"
                    }}
                  </span>
                </td>
                <td>
                  <span
                    class="badge align-items-center py-1 px-2 card-badge"
                    :class="[
                      data.room_status == 'd'
                        ? 'badge-soft-danger'
                        : data.room_status == 'c'
                        ? 'badge-soft-success'
                        : data.room_status == 'p'
                        ? 'badge-soft-warning'
                        : 'badge-soft-dark',
                    ]"
                  >
                    {{
                      data.room_status == "d"
                        ? "Dirty"
                        : data.room_status == "c"
                        ? "Clean"
                        : data.room_status == "p"
                        ? "Pickup"
                        : "Unknown"
                    }}
                  </span>
                </td>
                <td>
                  <img
                    v-if="data.staff_image !== ''"
                    class="rounded-circle picture-img"
                    :src="data.staff_image"
                    alt="Avatar"
                  />
                  <div v-else>
                    <span
                      class="d-flex align-items-center justify-content-center bg-soft bg-primary font-20 rounded-circle picture-img"
                    >
                      {{ avatarGenerator(data.attendant) }}
                    </span>
                  </div>
                </td>
                <td>{{ data.attendant }}</td>
                <td>{{ data.inspection == true ? "Yes" : "No" }}</td>
                <td>{{ data.room_type }}</td>
                <td>{{ data.credit }}</td>
                <td>{{ data.start_time }}</td>
                <td>{{ data.end_time }}</td>
                <td>{{ data.remaining_time }}</td>
                <td>
                  {{ data.guest_name }}
                  <i
                    v-if="data.guest_name != '-'"
                    class="fa fa-info-circle mb-0 ms-1 me-2"
                    :title="data.guest_name"
                    v-b-popover.hover="`Task status : ${data.task_status}`"
                  ></i>
                </td>
                <td>
                  <b-dropdown
                    size="sm"
                    variant="white"
                    toggle-class="p-0"
                    menu-class="dropdown-menu-end"
                    right
                  >
                    <template #button-content>
                      <i class="fas fa-ellipsis-v"></i>
                    </template>
                    <b-dropdown-item
                      v-for="(status, index) in data.statusOptions"
                      :key="index"
                      @click="updateStatus(data.taskId, status.type)"
                    >
                      {{ status.name }}
                    </b-dropdown-item>
                  </b-dropdown>
                </td>
              </tr>
            </tbody>
            <tbody v-if="!table.isDataLoading && table.tableData.length == 0">
              <tr>
                <td colspan="18" class="text-center">
                  <img
                    src="@/assets/images/empty.svg"
                    class="img-fluid"
                    alt=""
                  />
                  <p>
                    <span class="text-secondary">No Data Found</span>
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <b-modal
      id="reason-modal"
      centered
      :title="reasonTitle"
      hide-footer
      title-class="font-18"
      @hidden="resetModal"
      ref="reason-modal"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group :label="reasonStatus" label-for="name-input">
          <p slot="label">
            {{ reasonStatus }} Reason <span class="text-danger">*</span>
          </p>
          <MultiSelect
            v-model="reason"
            :options="reasonOptions"
            :show-labels="false"
            placeholder="reason"
            track-by="value"
            label="text"
            :class="{
              'is-invalid': submitted && $v.reason.$error,
            }"
          />
          <div v-if="submitted" class="invalid-feedback">
            <span v-if="!$v.reason.required">Reason is required.</span>
          </div>
        </b-form-group>
        <div class="row">
          <div class="col-md-12">
            <button
              class="btn btn-primary me-2 float-end mt-2"
              @click="handleOk"
            >
              Update
            </button>
          </div>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<style scoped>
.grab-bing {
  cursor: -webkit-grab;
  cursor: -moz-grab;
  cursor: -o-grab;
  cursor: grab;
}

.grab-bing:active {
  cursor: -webkit-grabbing;
  cursor: -moz-grabbing;
  cursor: -o-grabbing;
  cursor: grabbing;
}

.hk-center th,
.hk-center td {
  text-align: center;
}
</style>
